import moment from 'moment'

export function RogersLeadsStatisticsService($http, apexApiUrl) {
    'ngInject'
    const service = {
        retrieveTotalStatistics: retrieveTotalStatistics,
        retrieveOfficeStatistics: retrieveOfficeStatistics,
        retrieveRepStatistics: retrieveRepStatistics
    };

    return service;

    /**
     * Get the singular statistics aggregate representing all statistics
     * matching the given query
     * @param {any} query The query object
     * @returns {Promise<any>} The statistics data.
     */
    function retrieveTotalStatistics(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "/reports/rogers/leads-total-statistics",
            params: mapQueryToParams(query)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Get a list of statistics broken down by office.
     * @param {any} query The query object
     * @returns {Promise<any>} The statistics broken down by office
     */
    function retrieveOfficeStatistics(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "/reports/rogers/leads-office-statistics",
            params: mapQueryToParams(query)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Get a list of statistics broken down by rep.
     * @param {any} query The query object
     * @returns {Promise<any>} The statistics data broken down by rep.
     */
    function retrieveRepStatistics(query) {
        return $http({
            method: "GET",
            url: apexApiUrl + "/reports/rogers/leads-rep-statistics",
            params: mapQueryToParams(query)
        }).then(function (response) {
            return response.data;
        });
    }

    /**
     * Map a statistics query into query string parameters.
     * @param {any} query The query object to be mapped to a params object
     * @returns {any} The URL-serializable params.
     */
    function mapQueryToParams(query) {
        const params = {
            leadBatchID: query.leadBatchID,
            leadGroupID: query.leadGroupID,
            icdOfficeID: query.icdOffices,
            employeeID: query.employees,
            userID: query.userID
        };

        if (query.startDate) {
            params.startDate = moment(query.startDate).format("YYYY-MM-DD");
        }

        if (query.endDate) {
            params.endDate = moment(query.endDate).format("YYYY-MM-DD");
        }

        return params;
    }
}
